import { Navigation, Scrollbar } from "swiper/modules";
import { SwiperOptions } from "swiper/types";

export const newsCardSliderOptions: SwiperOptions = {
  modules: [Scrollbar],
  slidesPerGroup: 1,
  grabCursor: true,
  speed: 700,
  direction: "horizontal",
  observer: true,
  mousewheel: {
    forceToAxis: true,
  },
  scrollbar: {
    enabled: true,
    draggable: true,
    hide: false,
    el: ".swiper-scrollbar",
  },
  injectStyles: [
    `
   .swiper {
        overflow: visible;     
      } 
    `,
  ],
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 35,
    },
    768: {
      slidesPerView: "auto",
      spaceBetween: 50,
    },
    1190: {
      slidesPerView: "auto",
      spaceBetween: 80,
    },
    1500: {
      slidesPerView: "auto",
      spaceBetween: 200,
    },
    1600: {
      slidesPerView: "auto",
      spaceBetween: 200,
    },
  },
};
